/* FP Garage v2: multi-truck store on localStorage (pattern: fp_wishlist_v1).
   v2 (2026-07-06, FP_VIN_V2_PLAN): trucks carry an optional engine
   {parent,child,era,label|other}, vin, type ('truck'|'trailer') and source
   ('ymm'|'vin'). fp_garage_v1 is migrated on first read (copy - NEVER deleted;
   old tabs on cached JS keep working and their v1 writes are absorbed via the
   storage listener). Renders chips into any [data-fp-garage]; renders the PDP
   fits-check badge into [data-fp-fitcheck] and compact card badges into
   [data-fp-cardfit] (both read data-keys / data-engine-keys / data-spec-keys /
   data-fp-category). One pure verdict() drives both (exported on FPGarage for
   the fits-only toggle). Watches #ProductGridContainer - Athens facets.js
   replaces its innerHTML on filter/sort/Load more. Exposes window.FPGarage. */
(function () {
  if (window.FPGarage) return;
  var KEY = 'fp_garage_v2';
  var LEGACY = 'fp_garage_v1';
  /* Display list for the one engine question - canon: scripts/data/fitment/
     engines.json `engines[].value` (9 parents). Vocabulary changes are a
     Nicolas decision; update here + engines.json together. */
  var ENGINE_PARENTS = ['Detroit DD13', 'Detroit DD15', 'Detroit DD16',
    'Volvo D11', 'Volvo D13', 'Mack MP7', 'Mack MP8', 'Cummins ISX15', 'Cummins X15'];
  /* Engine-primary product types - canon: engines.json categories.engine_primary.
     A truck-only match on these must show the verify_by honesty line. */
  var ENGINE_PRIMARY = {
    'Exhaust & Emission Systems': 1, 'Exhaust & Emission Sensors': 1,
    'Exhaust Components': 1, 'Engine Gaskets & Seals': 1, 'Engine Components': 1,
    'Engine Sensors': 1, 'Belts & Tensioners': 1, 'Water Pumps & Thermostats': 1,
    'AC Compressors & Blower Motors': 1
  };
  /* SPEC-PRIMARY: clutches fit by TRANSMISSION, not truck/engine. The automated
     transmission is MAKE-LOCKED (Volvo=I-Shift, Freightliner/Cascadia=Detroit
     DT12, Mack=mDrive, Kenworth/Peterbilt=Eaton Endurant), so clutches AUTO-CROSS
     off the VIN by make - no question (Nicolas 2026-07-08 "auto for any truck").
     EVERY decodable make is mapped, so any VIN a customer enters crosses. A DT12
     clutch on a Volvo is a hard nofit. Backlog: PACCAR TX-12 (when stocked) + the
     manual Eaton Fuller per-truck list. */
  var SPEC_PRIMARY = {
    'Clutch Kits & Assemblies': 1, 'Clutch Solenoid Valves': 1
  };
  /* Where to go and LOOK for a spec part's number, per category. The check_spec
     line used to end "Compare with the suspension hanger / axle tag" for every
     spec part, because when it was written only air springs reached that branch.
     Once hub caps, air fittings and brake chambers moved onto the spec axis
     (2026-08-06) that sent a driver to the suspension to read a thread size.
     verdict() is synchronous and pure so it cannot fetch specs.json's per-family
     help text - but part.cat is right here, and hardcoded category maps are
     already how this file works (SPEC_PRIMARY, ENGINE_PRIMARY, MAKE_AMT).
     Trucker-plain: name the object to look at, not the abstraction. */
  var SPEC_WHERE = {
    'Air Bags': 'Compare it with the suspension hanger / axle tag before ordering.',
    'Suspension Hardware & Bushings': 'Compare it with the suspension hanger / axle tag before ordering.',
    'Wheel End (Seals & Bearings)': 'Count the bolts on your hub cap and measure across the circle they sit on before ordering.',
    'Air System Manifolds & Valves': 'The thread is stamped on the fitting body; the tube size is the air line it plugs into. Both ends have to match.',
    'Brake Chambers': 'The type and stroke are stamped on the chamber housing - a 30/30 and a 30/36 are not the same part.',
    'Brake Drums': 'The size is cast into the drum edge and printed on the axle tag.',
    'Slack Adjusters & Camshafts': 'Spline count and side (LH/RH) are on the axle tag.'
  };
  function specWhere(cat) {
    return SPEC_WHERE[cat] || 'Check that against your truck before ordering.';
  }
  var MAKE_AMT = {
    'Freightliner': 'DT12', 'Volvo': 'I-Shift', 'Mack': 'mDRIVE',
    'Kenworth': 'Endurant', 'Peterbilt': 'Endurant'
  };
  var AMT_BRANDS = { 'DT12': 1, 'I-Shift': 1, 'mDRIVE': 1, 'Endurant': 1 };
  /* Dual-source cutover: a make-locked AMT that shipped with TWO non-interchangeable
     parts across a production switch. A marker key in spec_keys ('ZF'/'LuK' on the DT12
     clutches; 'Gen 1-2'/'Gen 3' on the I-Shift/mDrive solenoid valves) + the model-year
     rule pins the one actually on the truck; the cutover MODEL YEAR itself can't be
     split from the VIN (build month isn't encoded), so it asks. DT12 proven against 75
     build records 2026-07-09 (Western Star + DD13/DD16 still to confirm). I-Shift/mDrive
     valve years = Nicolas's ruling 2026-07-14: SV-2001 2013-2017, SV-2002 2019-2024,
     2018 = both. earlyFrom/lateThru (optional) bound the VERIFIED window — outside it
     the badge asks instead of guessing (2025+ valves unverified; DT12 stays unbounded).
     One cutover pair per AMT; parts with AMT keys but NO marker key (e.g. the I-Shift
     clutch assembly) fall through to the old plain fit. */
  var AMT_MAKERS = {
    'ZF': 'ZF 6-spring', 'LuK': 'LuK 5-spring',
    'Gen 1-2': 'early type · 2013-2017', 'Gen 3': 'Gen 3 type · 2019+'
  };
  var VALVE_CUTOVER = {
    early: 'Gen 1-2', late: 'Gen 3', earlyFrom: 2013, earlyThru: 2017,
    lateFrom: 2019, lateThru: 2024, noun: 'valve', nouns: 'valves',
    /* sides = trucker-plain chooser copy (Nicolas 2026-07-15): each card tells
       the customer which old part numbers mean "this one" vs "the other one".
       Entries without sides (DT12) keep the original hint copy untouched. */
    sides: {
      'Gen 1-2': { nums: '21935705, 21712495 or 22327069', name: 'early 2013-2017 valve (SV-2001)' },
      'Gen 3': { nums: '22439692 or 85022032', name: 'Gen 3 valve (SV-2002)' }
    }
  };
  var CLUTCH_CUTOVER = {
    'DT12': { early: 'ZF', late: 'LuK', earlyThru: 2020, lateFrom: 2022,
      noun: 'clutch', nouns: 'clutches',
      hint: 'count the springs on your old cover: 5 = LuK, 6 = ZF' },
    'I-Shift': VALVE_CUTOVER, 'mDRIVE': VALVE_CUTOVER
  };

  function normTruck(t) {
    if (!t || !t.label) return null;
    return {
      make: t.make || '', model: t.model || '', year: t.year || '',
      value: t.value || '', label: t.label,
      engine: t.engine || null, vin: t.vin || null,
      type: t.type === 'trailer' ? 'trailer' : 'truck',
      source: t.source === 'vin' ? 'vin' : 'ymm',
      /* trailer extras (body token, length ft, answered spec values) */
      body: t.body || null, length: t.length || null,
      specs: Array.isArray(t.specs) ? t.specs : []
    };
  }
  function readLegacy() {
    try {
      var d = JSON.parse(localStorage.getItem(LEGACY) || 'null');
      if (d && Array.isArray(d.trucks)) return d;
    } catch (e) {}
    return null;
  }
  function read() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (d && d.v === 2 && Array.isArray(d.trucks)) {
        return { v: 2, trucks: d.trucks, active: Math.min(Number(d.active) || 0, d.trucks.length - 1) };
      }
    } catch (e) {}
    /* migrate: copy v1 -> v2 (engine:null). fp_garage_v1 stays untouched. */
    var legacy = readLegacy();
    if (legacy && legacy.trucks.length) {
      var st = {
        v: 2,
        trucks: legacy.trucks.map(normTruck).filter(Boolean),
        active: Math.min(Math.max(Number(legacy.active) || 0, 0), legacy.trucks.length - 1)
      };
      try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e2) {}
      return st;
    }
    return { v: 2, trucks: [], active: -1 };
  }
  function write(st) {
    try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {}
    renderAll();
    /* same-page listeners (nav pill etc.) - storage events fire cross-tab only */
    try { document.dispatchEvent(new CustomEvent('fp:garage-change')); } catch (e2) {}
  }
  function absorbLegacy() {
    /* a tab running cached v1 JS may still add trucks to fp_garage_v1 -
       pull in any label we don't have yet (engine:null). */
    var legacy = readLegacy();
    if (!legacy || !legacy.trucks.length) return;
    var st = read(), have = {}, added = false;
    st.trucks.forEach(function (t) { have[t.label] = 1; });
    legacy.trucks.forEach(function (t) {
      var n = normTruck(t);
      if (n && !have[n.label]) { st.trucks.push(n); have[n.label] = 1; added = true; }
    });
    if (added) write(st); else renderAll();
  }
  function engParentOf(t) {
    return t && t.engine ? (t.engine.parent || t.engine.other || null) : null;
  }
  function engShort(engine) {
    if (!engine) return '';
    if (!engine.parent) return engine.other || (engine.label || '');
    var p = String(engine.parent).split(' ').pop();
    return p + (engine.era ? ' · ' + engine.era : '');
  }
  /* Legacy/pre-guard garage records can carry a blank label (they render as an
     engine-only chip). Never show engine-only: fall back to year/make/model,
     then a generic "Truck · <engine>". */
  function truckLabel(t) {
    if (t && t.label) return t.label;
    var ymm = [t.year, t.make, t.model].filter(Boolean).join(' ');
    if (ymm) return ymm;
    if (t && t.type === 'trailer') return 'Trailer';
    var e = engShort(t && t.engine);
    return e ? 'Truck · ' + e : 'Truck';
  }
  function truckMeta(t) {
    var bits = [];
    if (t.type === 'trailer') {
      var tb = [t.body || 'trailer', t.length ? t.length + ' ft' : null].filter(Boolean).join(' · ');
      if (tb) bits.push(tb);
    } else if (t.engine) { bits.push(engShort(t.engine)); }
    if (t.vin) bits.push('VIN …' + String(t.vin).slice(-5));
    return bits.join(' · ');
  }
  function add(truck) {
    var t = normTruck(truck);
    /* a truck needs a gen key (value) OR at least a decoded make: VIN decodes
       of makes outside the picker vocab (Mack, Western Star, International...)
       save honestly as make-only trucks - value:'' keeps the truck axis
       silent while the AMT/clutch (make+year) and engine badges still work.
       Trailers were always valueless. Fully-anonymous adds stay rejected. */
    if (!t || !t.label || (!t.value && t.type !== 'trailer' && !t.make)) return;
    var st = read(), i, j, exactIdx = -1, labelIdx = -1;
    for (i = 0; i < st.trucks.length; i++) {
      if (st.trucks[i].label === t.label) {
        if (labelIdx === -1) labelIdx = i;
        if (engParentOf(st.trucks[i]) === engParentOf(t)) { exactIdx = i; break; }
      }
    }
    if (exactIdx !== -1) {
      j = exactIdx;
      /* refresh details a VIN decode may have enriched */
      if (t.engine) st.trucks[j].engine = t.engine;
      if (t.vin) { st.trucks[j].vin = t.vin; st.trucks[j].source = 'vin'; }
    } else if (labelIdx !== -1 && t.engine && !st.trucks[labelIdx].engine) {
      /* same truck, engine now known - upgrade in place, no duplicate chip */
      j = labelIdx;
      st.trucks[j].engine = t.engine;
      if (t.vin) { st.trucks[j].vin = t.vin; st.trucks[j].source = 'vin'; }
    } else if (labelIdx !== -1 && !t.engine) {
      /* engineless re-add of a truck we already know - just activate it */
      j = labelIdx;
    } else {
      st.trucks.push(t); j = st.trucks.length - 1;
    }
    st.active = j;
    write(st);
  }
  function remove(index) {
    var st = read();
    st.trucks.splice(index, 1);
    if (st.active >= st.trucks.length) st.active = st.trucks.length - 1;
    write(st);
  }
  function setActive(index) {
    var st = read();
    if (index >= 0 && index < st.trucks.length) { st.active = index; write(st); }
  }
  function setEngine(index, engine) {
    var st = read();
    if (index < 0 || index >= st.trucks.length) return;
    if (typeof engine === 'string') {
      engine = engine ? { parent: engine, child: null, era: null, label: engine } : null;
    }
    st.trucks[index].engine = engine || null;
    write(st);
  }
  function setActiveSpecs(values) {
    /* merge answered spec values (axle tag / drum stamp) into the active entry */
    var st = read();
    if (st.active < 0 || !Array.isArray(values)) return;
    var t = st.trucks[st.active];
    var have = t.specs = Array.isArray(t.specs) ? t.specs : [];
    values.forEach(function (v) { if (v && have.indexOf(v) === -1) have.push(v); });
    write(st);
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function engineSelect(onPick) {
    var sel = el('select', 'fp-garage__engsel');
    sel.appendChild(new Option('Which engine?', ''));
    ENGINE_PARENTS.forEach(function (p) { sel.appendChild(new Option(p, p)); });
    sel.appendChild(new Option('Not sure', '__none__'));
    sel.addEventListener('click', function (e) { e.stopPropagation(); });
    sel.addEventListener('change', function () {
      onPick(sel.value === '__none__' ? null : (sel.value || null));
    });
    return sel;
  }
  /* Vehicle switcher rows (redesign 2026-07-08): rendered into every
     [data-fp-garage] - the banner "Change" popover and the YMM picker. Each
     row = presence dot · name (fallback) · engine/VIN meta · active · remove.
     Colors are context-driven (dark text on the white popover, light on the
     hero card) - see .fp-veh in fp-ymm.css. */
  function renderGarage(mount) {
    var st = read();
    mount.innerHTML = '';
    mount.hidden = st.trucks.length === 0;
    st.trucks.forEach(function (t, i) {
      var on = i === st.active;
      var row = el('span', 'fp-veh' + (on ? ' on' : ''));
      row.setAttribute('role', 'button'); row.tabIndex = 0;
      row.appendChild(el('span', 'fp-veh__dot' + (t.vin ? '' : ' off')));
      var tx = el('span', 'fp-veh__tx');
      tx.appendChild(el('b', 'fp-veh__lbl', truckLabel(t)));
      var meta = truckMeta(t);
      if (meta) {
        tx.appendChild(el('small', 'fp-veh__meta', meta));
      } else if (t.type !== 'trailer' && !t.engine) {
        var addEng = el('small', 'fp-veh__meta fp-veh__addeng', '+ add engine');
        addEng.addEventListener('click', function (e) {
          e.stopPropagation();
          var sel = engineSelect(function (parent) { setEngine(i, parent); });
          tx.replaceChild(sel, addEng); sel.focus();
        });
        tx.appendChild(addEng);
      }
      row.appendChild(tx);
      if (on) row.appendChild(el('span', 'fp-veh__on', '✓ Active'));
      var x = el('button', 'fp-veh__x', '×');
      x.type = 'button'; x.setAttribute('aria-label', 'Remove ' + truckLabel(t));
      x.addEventListener('click', function (e) { e.stopPropagation(); remove(i); });
      row.appendChild(x);
      row.addEventListener('click', function () {
        setActive(i);
        if (window.FPYMM) { window.FPYMM.setTruck({ year: t.year, make: t.make, model: t.model, engine: t.engine, vin: t.vin }); }
      });
      row.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); row.click(); } });
      mount.appendChild(row);
    });
    if (st.trucks.length) {
      var addBtn = el('button', 'fp-veh__add', '+ Add a truck');
      addBtn.type = 'button';
      addBtn.addEventListener('click', function () {
        if (window.FPYMM && window.FPYMM.clear) window.FPYMM.clear();
        var picker = mount.closest && mount.closest('[data-fp-ymmw]');
        var make = picker && picker.querySelector('[data-fpy-make]');
        if (make) { make.focus(); } else { window.location.href = '/pages/search-by-truck'; }
      });
      mount.appendChild(addBtn);
    }
  }
  /* PDP badge - decision order (FP_VIN_V2_PLAN 3a / mockup frame 4):
     universal -> truck+engine -> truck-only (verify_by honesty on
     engine-sensitive parts) -> engine-only -> prompt -> no-fit. */
  var ICONS = {
    ok: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12l5 5 11-11"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v8M12 16.5v.5"/></svg>',
    no: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>'
  };
  function badge(node, cls, icon, main, small, addEngineIdx) {
    var box = el('div', 'fp-fitcheck ' + cls);
    box.innerHTML = ICONS[icon];
    var tx = el('span', 'fp-fitcheck__tx');
    tx.appendChild(el('b', '', main));
    if (small) tx.appendChild(el('small', '', small));
    if (addEngineIdx != null) {
      var btn = el('button', 'fp-fitcheck__addeng', 'Add engine');
      btn.type = 'button';
      btn.addEventListener('click', function () {
        var sel = engineSelect(function (parent) { setEngine(addEngineIdx, parent); });
        tx.replaceChild(sel, btn);
        sel.focus();
      });
      tx.appendChild(btn);
    }
    box.appendChild(tx);
    node.appendChild(box);
    node.hidden = false;
  }
  function partFromNode(node) {
    return {
      keys: (node.getAttribute('data-keys') || '').split('||').filter(Boolean),
      engKeys: (node.getAttribute('data-engine-keys') || '').split('||').filter(Boolean),
      specKeys: (node.getAttribute('data-spec-keys') || '').split('||').filter(Boolean),
      cat: node.getAttribute('data-fp-category') || ''
    };
  }
  /* ONE pure decision function behind the PDP badge and the card badges.
     Same order + copy as the pre-refactor renderFitcheck; only addition is
     the truck-user x spec-only-part case (was a nonsense "Made for ." nofit).
     Returns {state, cls, icon, main, small, addEngine}; 'none' = show nothing. */
  function verdict(active, part) {
    var keys = part.keys || [], engKeys = part.engKeys || [], specKeys = part.specKeys || [];
    if (!active || (!keys.length && !engKeys.length && !specKeys.length)) return { state: 'none' };
    var universal = keys.some(function (k) { return /^universal/i.test(k); });
    if (active.type === 'trailer') {
      /* trailer states: universal accessories fit; spec parts match the
         answered axle-tag values; truck-fitment parts stay silent. */
      var answered = active.specs || [];
      var specHit = specKeys.filter(function (k) { return answered.indexOf(k) !== -1; });
      if (universal) {
        return { state: 'universal', cls: 'ok', icon: 'ok',
          main: 'Universal part — works with your ' + active.label };
      }
      if (specHit.length) {
        return { state: 'fit', cls: 'ok', icon: 'ok',
          main: 'Matches your trailer — ' + specHit.join(', ') };
      }
      if (specKeys.length) {
        return { state: 'check_spec', cls: 'check', icon: 'check',
          main: 'Spec part — check the tag on your trailer',
          small: 'This one is ' + specKeys.slice(0, 3).join(', ') + '. Compare with the axle tag / drum stamp before ordering.' };
      }
      return { state: 'none' };
    }
    var truckOk = keys.indexOf(active.value) !== -1;
    var eng = active.engine;
    var engOk = !!(eng && eng.parent &&
      (engKeys.indexOf(eng.parent) !== -1 || (eng.child && engKeys.indexOf(eng.child) !== -1)));
    var engineSensitive = engKeys.length > 0 || ENGINE_PRIMARY[part.cat] === 1;

    if (universal) {
      return { state: 'universal', cls: 'ok', icon: 'ok',
        main: 'Fits all trucks — including your ' + active.label };
    }
    /* SPEC-PRIMARY (clutches): the automated transmission is make-locked, so
       auto-cross off the VIN by make (Excelerator reads it from the build record;
       the make hands it to us for free). KW/Pete + manual = backlog -> verify. */
    if (SPEC_PRIMARY[part.cat] && specKeys.length) {
      var truckAMT = MAKE_AMT[active.make];
      var amt = specKeys.filter(function (k) { return AMT_BRANDS[k]; });
      if (truckAMT) {
        if (amt.indexOf(truckAMT) !== -1) {
          var cut = CLUTCH_CUTOVER[truckAMT];
          var mk = specKeys.filter(function (k) { return AMT_MAKERS[k]; })[0];
          if (cut && mk) {
            /* two non-interchangeable parts for this AMT: pin by the model-year
               cutover; on the cutover year (build month absent from the VIN) we ask.
               Outside the verified window (earlyFrom/lateThru, when set) we also ask
               — never guess beyond the evidence. */
            var yr = parseInt(active.year, 10);
            var inWin = !!yr && !(cut.earlyFrom && yr < cut.earlyFrom) && !(cut.lateThru && yr > cut.lateThru);
            if (inWin && (yr <= cut.earlyThru || yr >= cut.lateFrom)) {
              var want = (yr <= cut.earlyThru) ? cut.early : cut.late;
              if (mk === want) {
                return { state: 'fit', cls: 'ok', icon: 'ok',
                  main: 'Fits your ' + active.label + ' — ' + truckAMT + ' (' + AMT_MAKERS[mk] + ')' };
              }
              return { state: 'nofit', cls: 'nofit', icon: 'no',
                main: 'Not your ' + cut.noun + ' — your ' + truckAMT + ' uses the ' + AMT_MAKERS[want],
                small: 'Your ' + active.label + ' shipped with the ' + AMT_MAKERS[want] + ' ' + cut.noun + '. This is the ' + AMT_MAKERS[mk] + '.' };
            }
            /* sides = per-part trucker copy ("your number = this one / that one");
               entries without sides (DT12) keep the original hint strings. */
            var mine = cut.sides && cut.sides[mk];
            var other = mine && cut.sides[mk === cut.early ? cut.late : cut.early];
            if (yr && !inWin) {
              if (mine) {
                return { state: 'check_spec', cls: 'check', icon: 'check',
                  main: 'Not confirmed for your ' + active.label + ' yet — check the number on your old ' + cut.noun,
                  small: 'This one is the ' + mine.name + '. If your old ' + cut.noun + ' says ' + mine.nums + ', it fits. If it says ' + other.nums + ', you need the ' + other.name + '. Not sure? Send us the VIN and we will check it for you.' };
              }
              return { state: 'check_spec', cls: 'check', icon: 'check',
                main: 'Not verified for your ' + active.label + ' — match your old part number',
                small: 'This is the ' + AMT_MAKERS[mk] + ' ' + cut.noun + '; fitment for your year is not confirmed yet — ' + cut.hint + '. Or send us the VIN.' };
            }
            if (mine) {
              /* the straddle year(s), e.g. 2018 for the valves */
              var straddle = String(cut.earlyThru + 1) + (cut.lateFrom - cut.earlyThru > 2 ? '-' + (cut.lateFrom - 1) : '');
              return { state: 'check_spec', cls: 'check', icon: 'check',
                main: (yr ? yr + ' trucks came with either ' + cut.noun : 'Your truck came with one of two ' + cut.nouns) + ' — check the number on your old one',
                small: 'The factory switched ' + cut.nouns + ' during ' + straddle + ', so both are on the road. Find the part number printed on your current ' + cut.noun + ' (or on an old invoice). If it says ' + mine.nums + ' — this is your ' + cut.noun + '. If it says ' + other.nums + ' — you need the ' + other.name + ' instead. Not sure? Send us the VIN and we will check it for you.' };
            }
            return { state: 'check_spec', cls: 'check', icon: 'check',
              main: 'One of two ' + truckAMT + ' ' + cut.nouns + ' — match your old part number',
              small: 'Your ' + (active.year ? active.year + ' ' : '') + (active.make || 'truck') + ' shipped with either ' + cut.noun + ' (mid-year switch). This is the ' + AMT_MAKERS[mk] + ' — ' + cut.hint + '.' };
          }
          return { state: 'fit', cls: 'ok', icon: 'ok',
            main: 'Fits your ' + active.label + ' — ' + truckAMT + ' transmission' };
        }
        if (amt.length) {
          return { state: 'nofit', cls: 'nofit', icon: 'no',
            main: "Doesn't fit your " + active.label,
            small: 'This is a ' + amt[0] + ' clutch — your ' + (active.make || 'truck') + ' runs the ' + truckAMT + '.' };
        }
        return { state: 'check_spec', cls: 'check', icon: 'check',
          main: 'Manual clutch — check your transmission',
          small: 'For older / manual trucks. Your ' + (active.make || 'truck') + ' usually runs the ' + truckAMT + ' — confirm before ordering.' };
      }
      return { state: 'check_spec', cls: 'check', icon: 'check',
        main: 'Clutch — check your transmission',
        small: 'Match your transmission (' + specKeys.slice(0, 3).join(', ') + ') before ordering.' };
    }
    if (truckOk && engOk) {
      return { state: 'fit_engine', cls: 'ok', icon: 'ok',
        main: 'Fits your ' + active.label + ' — engine confirmed (' + engShort(eng) + ')' };
    }
    if (truckOk && engineSensitive) {
      /* canonical honesty copy (engines.json 2026-07-02 / mockup 4b) */
      if (!eng) {
        return { state: 'check_engine', cls: 'check', icon: 'check', addEngine: true,
          main: 'Fits your truck — better check with engine or by VIN',
          small: 'This part depends on the engine. Add your engine (one tap) or send us the VIN — we verify on the build sheet.' };
      }
      return { state: 'check_engine', cls: 'check', icon: 'check',
        main: 'Fits your truck — better check with engine or by VIN',
        small: 'This part depends on the engine/era — double-check by VIN or OEM number before ordering.' };
    }
    if (truckOk) {
      return { state: 'fit', cls: 'ok', icon: 'ok', main: 'Fits your ' + active.label };
    }
    if (engOk) {
      return { state: 'engine_only', cls: 'eng', icon: 'ok',
        main: 'Fits your engine — ' + (eng.child || eng.parent),
        small: "Engine-mounted part: truck model doesn't matter." };
    }
    if (engKeys.length && !keys.length && !eng) {
      return { state: 'engine_prompt', cls: 'eng', icon: 'check', addEngine: true,
        main: 'Engine-fit part — add your engine or VIN to check fit' };
    }
    if (!keys.length && !engKeys.length && specKeys.length) {
      /* spec part viewed with a truck active (P4 adds the one-tap question here;
         until then honest guidance, not a false nofit) */
      return { state: 'check_spec', cls: 'check', icon: 'check',
        main: 'Spec part — check the tag on your truck',
        small: 'This one is ' + specKeys.slice(0, 3).join(', ') + '. ' + specWhere(part.cat) };
    }
    var madeFor = (keys.length ? keys : engKeys).slice(0, 3).join(', ');
    return { state: 'nofit', cls: 'nofit', icon: 'no',
      main: "Doesn't fit your " + active.label,
      small: 'Made for ' + madeFor + '. Switch truck in the garage to double-check.' };
  }
  /* lazy fp-vin-maps.json cache (PDP spec asker needs the question text +
     truck_spec_families allow-list; the card grid never loads it) */
  var MAPS_CACHE = {};
  function loadMaps(src) {
    if (!MAPS_CACHE[src]) {
      MAPS_CACHE[src] = fetch(src).then(function (r) { return r.json(); });
    }
    return MAPS_CACHE[src];
  }
  /* Phase 4 - virtual build sheet: on a TRUCK PDP, a spec-only part whose
     family is truck-askable gets ONE question; the answer is written onto the
     active VIN (setActiveSpecs) so every suspension part then verifies. */
  function renderSpecAsk(node, specKeys, activeIdx) {
    var src = node.getAttribute('data-fp-maps-src');
    if (!src) return;
    loadMaps(src).then(function (maps) {
      var askable = (maps && maps.truck_spec_families) || [];
      var fams = (maps && maps.trailer_spec_questions) || [];
      var fam = null;
      for (var i = 0; i < fams.length; i++) {
        if (askable.indexOf(fams[i].family) === -1) continue;
        var vals = fams[i].values || [];
        if (specKeys.some(function (k) { return vals.indexOf(k) !== -1; })) { fam = fams[i]; break; }
      }
      if (!fam) return;
      var choices = specKeys.filter(function (k) { return (fam.values || []).indexOf(k) !== -1; });
      if (!choices.length) return;
      /* the node may have been re-rendered (garage change) while we fetched */
      if (node.dataset.fpAsk === fam.family || !node.querySelector('.fp-fitcheck')) return;
      node.dataset.fpAsk = fam.family;
      var wrap = el('div', 'fp-fitask');
      wrap.appendChild(el('p', 'fp-fitask__q', fam.question || 'Which one matches your truck?'));
      var row = el('div', 'fp-fitask__chips');
      choices.forEach(function (val) {
        var b = el('button', 'fp-fitask__chip', val);
        b.type = 'button';
        b.addEventListener('click', function () { setActiveSpecs([val]); });
        row.appendChild(b);
      });
      var skip = el('button', 'fp-fitask__chip fp-fitask__chip--ghost', 'Not sure — keep browsing');
      skip.type = 'button';
      skip.addEventListener('click', function () { wrap.parentNode && wrap.parentNode.removeChild(wrap); });
      row.appendChild(skip);
      wrap.appendChild(row);
      node.appendChild(wrap);
    }).catch(function () {});
  }
  function renderFitcheck(node) {
    var st = read(), active = st.trucks[st.active];
    node.innerHTML = '';
    node.hidden = true;
    node.dataset.fpAsk = '';
    var part = partFromNode(node);
    var v = verdict(active, part);
    if (v.state === 'none') return;
    badge(node, 'fp-fitcheck--' + v.cls, v.icon, v.main, v.small || null, v.addEngine ? st.active : null);
    if (v.state === 'check_spec' && active && active.type !== 'trailer' && part.specKeys.length) {
      renderSpecAsk(node, part.specKeys, st.active);
    }
  }
  /* Compact per-card labels (copy: G0 sheet 2026-07-08) */
  function cardLabel(v, active) {
    switch (v.state) {
      case 'universal': return { tone: 'uni', tick: '', text: 'Universal fit' };
      case 'fit_engine': return { tone: 'fit', tick: '✓', text: 'Verified for your truck' };
      case 'fit': return { tone: 'fit', tick: '✓',
        text: active.type === 'trailer' ? 'Matches your trailer' : 'Fits your ' + active.label };
      case 'check_spec': return { tone: 'check', tick: '', text: 'Fits — 1 question' };
      case 'check_engine': return { tone: 'check', tick: '', text: 'Fits — verify engine' };
      case 'engine_only': return { tone: 'fit', tick: '✓',
        text: 'Fits your ' + String(engShort(active.engine)).split(' · ')[0] };
      case 'engine_prompt': return { tone: 'check', tick: '', text: 'Add engine to check fit' };
      case 'nofit': return { tone: 'no', tick: '✕', text: 'Not for your truck' };
      default: return null;
    }
  }
  function cardSig(active) {
    if (!active) return 'none';
    return active.label + '|' + (engParentOf(active) || '') + '|' + (active.specs || []).join(',');
  }
  function renderCardFit(node) {
    var st = read(), active = st.trucks[st.active];
    var sig = cardSig(active);
    if (node.dataset.fpSig === sig) return;
    node.dataset.fpSig = sig;
    node.dataset.fpState = '';
    var v = verdict(active, partFromNode(node));
    var lbl = v.state === 'none' ? null : cardLabel(v, active);
    if (!lbl) {
      /* No verdict to show. With a truck ACTIVE, this part has no machine fitment
         data to judge against it - do NOT restore the generic "Fits X" SSR text
         (misleading on a different-make truck, e.g. "Fits Volvo VNL" on a
         Freightliner). Blank the row; the fits-only toggle then hides it. With no
         active truck, restore the SSR generic text. */
      if (active) {
        if (node.dataset.fpSsr == null) node.dataset.fpSsr = node.innerHTML;
        node.innerHTML = '';
      } else if (node.dataset.fpSsr != null) {
        node.innerHTML = node.dataset.fpSsr;
      }
      return;
    }
    if (node.dataset.fpSsr == null) node.dataset.fpSsr = node.innerHTML;
    node.dataset.fpState = v.state;
    node.innerHTML = '';
    var b = el('span', 'fp-cardfit fp-cardfit--' + lbl.tone);
    if (lbl.tick) b.appendChild(el('i', '', lbl.tick + ' '));
    b.appendChild(document.createTextNode(lbl.text));
    node.appendChild(b);
  }
  /* site-wide vehicle banner (snippets/fp-vehicle-banner.liquid; its inline
     first-paint script mirrors this exactly - keep the two in sync) */
  function maskVin(v) {
    /* Show the FULL VIN (Nicolas 2026-07-08): it's the customer's own truck on
       their own screen; the banner CSS gives it room / its own line on mobile. */
    return String(v || '');
  }
  function renderBanner(root) {
    var st = read(), active = st.trucks[st.active] || null;
    /* keep the card fit-row reserve gate live (banner sets it first-paint) */
    document.documentElement.classList.toggle('fp-has-vehicle', !!(active && active.label));
    var act = root.querySelector('[data-fpb-active]');
    var emp = root.querySelector('[data-fpb-empty]');
    if (!act || !emp) return;
    if (active && active.label) {
      root.querySelector('[data-fpb-label]').textContent = active.label;
      var es = active.type === 'trailer'
        ? [active.body || 'trailer', active.length ? active.length + ' ft' : ''].filter(Boolean).join(' · ')
        : engShort(active.engine);
      root.querySelector('[data-fpb-eng]').textContent = es ? ' · ' + es : '';
      var vinEl = root.querySelector('[data-fpb-vin]');
      if (active.vin && String(active.vin).length === 17) {
        vinEl.querySelector('code').textContent = maskVin(active.vin);
        vinEl.hidden = false;
      } else { vinEl.hidden = true; }
      act.hidden = false; emp.hidden = true;
    } else {
      /* banner is the single control (Nicolas 2026-07-08): empty/cleared states
         show the CTA - "Pick your truck →" (opens the switcher popover) when
         trucks exist, else "Set my truck →" (to the finder). */
      var cta = root.querySelector('[data-fpb-cta]');
      if (cta) {
        if (st.trucks.length) { cta.textContent = 'Pick your truck →'; cta.setAttribute('data-fpb-open', '1'); }
        else { cta.textContent = 'Set my truck →'; cta.removeAttribute('data-fpb-open'); }
      }
      act.hidden = true; emp.hidden = false;
    }
  }
  function renderAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fp-garage]'), renderGarage);
    Array.prototype.forEach.call(document.querySelectorAll('[data-fp-fitcheck]'), renderFitcheck);
    Array.prototype.forEach.call(document.querySelectorAll('[data-fp-cardfit]'), renderCardFit);
    Array.prototype.forEach.call(document.querySelectorAll('[data-fp-vbanner]'), renderBanner);
    /* the fits-only toggle (fp-fit-toggle.js) re-applies after every pass */
    try { document.dispatchEvent(new CustomEvent('fp:cards-rendered')); } catch (e) {}
  }
  /* Athens facets.js swaps #ProductGridContainer innerHTML on every filter /
     sort / Load more append - re-badge whatever arrives. Badge writes re-fire
     the observer once; the fpSig guard makes that pass a no-op (no loop). */
  var gridPending = false;
  function watchGrid() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid || grid.dataset.fpGarageWatch) return;
    grid.dataset.fpGarageWatch = '1';
    new MutationObserver(function () {
      if (gridPending) return;
      gridPending = true;
      requestAnimationFrame(function () { gridPending = false; renderAll(); });
    }).observe(grid, { childList: true, subtree: true });
  }
  window.FPGarage = {
    list: function () { return read().trucks.slice(); },
    getActive: function () { var st = read(); return st.trucks[st.active] || null; },
    add: add, remove: remove, setActive: setActive, setEngine: setEngine,
    setActiveEngine: function (engine) {
      var st = read();
      if (st.active >= 0) setEngine(st.active, engine);
    },
    setActiveSpecs: setActiveSpecs,
    clearActive: function () {
      /* "Shop without vehicle" - keep the garage, deactivate the truck.
         read() clamps with Math.min so -1 round-trips (verified). */
      var st = read();
      st.active = -1;
      write(st);
    },
    verdict: verdict,
    engineParents: ENGINE_PARENTS.slice(),
    mount: function (root) { renderAll(); }
  };
  window.addEventListener('storage', function (e) {
    if (!e || e.key === KEY || e.key === null) { renderAll(); }
    else if (e.key === LEGACY) { absorbLegacy(); }
  });
  function boot() { renderAll(); watchGrid(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  /* theme editor re-renders sections in place - re-badge + re-attach the grid watcher */
  document.addEventListener('shopify:section:load', boot);
})();
